import React from "react"
import {
  PageBlockContent,
  PageBlockHeading,
  PageBlockRow,
  PageBlockRowSection,
  PageBlockWrapper,
  paginated,
  useAppContext,
} from "@dit/core-frontend"
import { ZonesList, ZoneCreateTarget } from "@components/zones"
import { Box, Text } from "@mos-cat/ds"
import { Add } from "@mos-cat/ds-icons"
import { checkPermission } from "@src/store/permissionModel"
import HubLink from "@components/general/HubLink"
import { useInfiniteQuery } from "@tanstack/react-query"

const ZonesBlock = () => {
  const { isMoshub } = useAppContext()
  const { data } = useInfiniteQuery({
    ...paginated({
      queryKey: ["zones", {}, true],
    }),
  })

  return (
    <PageBlockWrapper>
      <HubLink type="projects" items={data?.items || []} />
      <PageBlockRow place="middle">
        <PageBlockRowSection>
          <PageBlockHeading>Мои разделы</PageBlockHeading>
        </PageBlockRowSection>
        {checkPermission("ZONE_CREATE") && !isMoshub && (
          <PageBlockRowSection>
            <ZoneCreateTarget>
              <Text
                as={Box}
                display="flex"
                alignItems="center"
                gridGap="5px"
                color="blue-60"
                fontSize="fs-14"
              >
                <Add /> Создать новый раздел
              </Text>
            </ZoneCreateTarget>
          </PageBlockRowSection>
        )}
      </PageBlockRow>
      <PageBlockContent minHeight="287px">
        <ZonesList view="cards" userZone />
      </PageBlockContent>
    </PageBlockWrapper>
  )
}

export default ZonesBlock
